import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { projectDataClient } from '../lib/connect/clients';
import { projectVolumesKeys } from './useProjectVolumes';
export const volumeDocumentKeys = {
    all: [
        'volumeDocuments'
    ],
    list: (projectId, volumeId)=>[
            ...volumeDocumentKeys.all,
            'list',
            projectId,
            volumeId
        ]
};
export function useVolumeDocuments(projectId, volumeId) {
    return useQuery({
        queryKey: volumeDocumentKeys.list(projectId ?? '', volumeId ?? ''),
        queryFn: async ()=>{
            if (!projectId || !volumeId) return [];
            const response = await projectDataClient.listVolumeDocuments({
                projectId,
                volumeId
            });
            return response.documents ?? [];
        },
        enabled: !!projectId && !!volumeId,
        staleTime: 30000
    });
}
export function useAddVolumeDocument() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ projectId, volumeId, label, documentType, sourceAttachmentId, submissionFilename })=>{
            const response = await projectDataClient.addVolumeDocument({
                projectId,
                volumeId,
                label,
                documentType: documentType ?? '',
                sourceAttachmentId: sourceAttachmentId ?? '',
                submissionFilename: submissionFilename ?? ''
            });
            return response.document;
        },
        onSuccess: (_doc, { projectId, volumeId })=>{
            queryClient.invalidateQueries({
                queryKey: volumeDocumentKeys.list(projectId, volumeId)
            });
            queryClient.invalidateQueries({
                queryKey: projectVolumesKeys.list(projectId)
            });
        }
    });
}
export function useUpdateVolumeDocument() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ projectId, volumeDocumentId, label, submissionFilename })=>{
            const response = await projectDataClient.updateVolumeDocument({
                projectId,
                volumeDocumentId,
                label: label ?? '',
                submissionFilename: submissionFilename ?? ''
            });
            return response.document;
        },
        onSuccess: (_doc, { projectId })=>{
            queryClient.invalidateQueries({
                queryKey: volumeDocumentKeys.all
            });
            queryClient.invalidateQueries({
                queryKey: projectVolumesKeys.list(projectId)
            });
        }
    });
}
export function useRemoveVolumeDocument() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ projectId, volumeDocumentId })=>{
            await projectDataClient.removeVolumeDocument({
                projectId,
                volumeDocumentId
            });
        },
        onSuccess: (_void, { projectId })=>{
            queryClient.invalidateQueries({
                queryKey: volumeDocumentKeys.all
            });
            queryClient.invalidateQueries({
                queryKey: projectVolumesKeys.list(projectId)
            });
        }
    });
}
